export default () => {
  return {
    count: () => {},
    timing: () => {},
    gauge: () => {},
    addGlobalTags: () => {},
    replaceGlobalTags: () => {},
    sendPagePerformance: () => {},
    sendInitialLoadTime: () => {},
    flush: () => {},
  };
};



// WEBPACK FOOTER //
// ./src/providers/disabled.js